var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";
import { forwardRef } from "react";

const SvgDelete = (_ref, ref) => {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 5.99992C5.60949 5.99992 5.83334 6.22378 5.83334 6.49992V10.4999C5.83334 10.7761 5.60949 10.9999 5.33334 10.9999C5.0572 10.9999 4.83334 10.7761 4.83334 10.4999V6.49992C4.83334 6.22378 5.0572 5.99992 5.33334 5.99992Z",
    fill: "#01040B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83334 6.49992C8.83334 6.22378 8.60949 5.99992 8.33334 5.99992C8.0572 5.99992 7.83334 6.22378 7.83334 6.49992V10.4999C7.83334 10.7761 8.0572 10.9999 8.33334 10.9999C8.60949 10.9999 8.83334 10.7761 8.83334 10.4999V6.49992Z",
    fill: "#01040B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33334 0.833252C4.93552 0.833252 4.55399 0.991287 4.27268 1.27259C3.99138 1.5539 3.83334 1.93543 3.83334 2.33325V2.99992H0.833344C0.557201 2.99992 0.333344 3.22378 0.333344 3.49992C0.333344 3.77606 0.557201 3.99992 0.833344 3.99992H1.83334V12.6499C1.83334 13.0495 1.98941 13.4344 2.26977 13.7194C2.55042 14.0048 2.93283 14.1666 3.33334 14.1666H10.3333C10.7339 14.1666 11.1163 14.0048 11.3969 13.7194C11.6773 13.4344 11.8333 13.0495 11.8333 12.6499V3.99992H13.1667C13.4428 3.99992 13.6667 3.77606 13.6667 3.49992C13.6667 3.22378 13.4428 2.99992 13.1667 2.99992H9.83334V2.33325C9.83334 1.93543 9.67531 1.5539 9.394 1.27259C9.1127 0.991287 8.73117 0.833252 8.33334 0.833252H5.33334ZM4.97979 1.9797C5.07356 1.88593 5.20074 1.83325 5.33334 1.83325H8.33334C8.46595 1.83325 8.59313 1.88593 8.6869 1.9797C8.78067 2.07347 8.83334 2.20064 8.83334 2.33325V2.83325H4.83334V2.33325C4.83334 2.20064 4.88602 2.07347 4.97979 1.9797ZM2.83334 3.99992H10.8333V12.6499C10.8333 12.7896 10.7787 12.9219 10.684 13.0182C10.5896 13.1142 10.4633 13.1666 10.3333 13.1666H3.33334C3.20343 13.1666 3.07713 13.1142 2.9827 13.0182C2.888 12.9219 2.83334 12.7896 2.83334 12.6499V3.99992Z",
    fill: "#01040B"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Delete.e24f324bf1b993f52f83782645ec137f.svg";